import { NgModule } from '@angular/core';

import { ProgressSpinnerComponent } from './progress-spinner.component';
import { ProgressSpinnerService } from './progress-spinner.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@NgModule({
    imports: [
        MatProgressSpinnerModule
    ],
    exports: [
        ProgressSpinnerComponent,
        MatProgressSpinnerModule
    ],
    declarations: [ProgressSpinnerComponent],
    providers: [
        ProgressSpinnerService
    ],
})
export class ProgressSpinnerModule { }
